<template>
  <div class="p-4 bg-light min-vh-100">
    <!-- <div class="d-flex justify-content-between mb-4">
      <h3 class="text-cyan fw-bold">Yangi Mijoz Qo'shish</h3>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary" @click="$router.push('/malumot/kontragent/index')">Bekor qilish</button>
        <button class="btn btn-success px-4" @click="$root.$refs.kontragent.Savedokument()">Saqlash</button>
      </div>
    </div> -->

    <kontragent-form :datas="dataall"></kontragent-form>

    <!-- Saqlanmagan ma'lumotlar haqida modal -->
    <b-modal id="modal-close" centered title="Diqqat!">
      <p class="m-0">Sizda saqlanmagan ma'lumotlar mavjud. Saqlansinmi?</p>
      <template #modal-footer="{ cancel }">
        <button class="btn btn-success" @click="$root.$refs.kontragent.Savedokument()">Ha</button>
        <button class="btn btn-danger" @click="forceExit()">Yo'q</button>
        <button class="btn btn-primary" @click="cancel()">Bekor qilish</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { KontragentForm } from "@/pages";

export default {
  components: { KontragentForm },
  data() {
    return {
      dataall: {
        name: "", phone_number: "", parent_id: 0, address: "",
        inn: "", mfo_id: "", is_folder: false, type: 1, sale_type: "chakana",
        sklad_id: parseInt(localStorage.getItem('sklad_id')) || 1,
        comment: "", 
        password: "123456"
      }
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler() { this.$store.state.saved += 1; }
    }
  },
  methods: {
    forceExit() {
      this.$store.state.saved = null;
      this.$router.push({ name: "Контрагент" });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>